import React, { useState, useCallback, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";  
import axios from "axios";

import GenericTemplate from "../../../templates/GenericTemplate";
import {
  apollo_useStyles,
} from "../../../atom/Apollo_styles";
import {
  get_zeus_resources_tags_path,
  zeus_ad_account,
  isummary_path,
} from "../../../atom/Apollo_links";
import { ApolloMessage, CustomizedSnackbars } from "../../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { ApolloRightDrawerContext } from "../../../molecule/Apollo_RightDrawer";
import { ApolloTabPanel, ApolloTabs2 } from "../../../atom/Apollo_Tabs";
import { APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission } from "../../../atom/Apollo_Authorization";
import { ApolloBreadcrumbs2, BreadcrumbsData } from "../../../atom/Apollo_Breadcrumbs2";
import {ApolloAxios, getResultType} from "../../../atom/Apollo_ApiRequest3";

import {
  tagsAsset,
} from "./common/TagsAssetModel";
import {
  options_tagtype_zeus,
  options_size_zeus,
} from "./common/CommonConst";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Typography from "@material-ui/core/Typography";
import { HTMLHint } from 'htmlhint';
import * as acorn from "acorn";
import {checkInvalidCharForName,getTextStrCheckErrorMsg} from "../../../common/Apollo_CommonUtil";

const animatedComponents = makeAnimated();
const BLANK = "";
const MAX_TAG_NAME_LENGTH = 255;
const MAX_SOURCE_LENGTH = 10000;
const INIT_TAGS: tagsAsset = {
  adAccountId: 0,
  zeusAccountName: BLANK,
  tagName: BLANK,
  width: 320,
  height: 180,
  tagType: 2,
  sourceCode: BLANK,
};

function utf8ToBase64(str: string): string {
  return window.btoa(unescape(encodeURIComponent(str)));
}

export const extractScriptBlocks = (html: string): string[] => {
  const result: string[] = [];
  const regex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
  let match: RegExpExecArray | null;

  while ((match = regex.exec(html)) !== null) {
    const content = match[1]?.trim();
    if (content) {
      result.push(content);
    }
  }

  return result;
};

export const areValidScriptBlocks = (scripts: string[]): boolean => {
  return scripts.every((code) => {
    try {
      acorn.parse(code, { ecmaVersion: "latest" });
      return true;
    } catch {
      return false;
    }
  });
};

const isValidHTMLWithHint = (html: string): boolean => {
  const ruleset = {
    "tag-pair": true,
    "attr-unsafe-chars": true,
    "doctype-first": false,
    "id-unique": false,
    "attr-value-double-quotes": false,
    "tagname-lowercase": false,
    "src-not-empty": false,
    "inline-script-disabled": false,
  };

  const result = HTMLHint.verify(html, ruleset);
  return result.length === 0;
};

export type SourceValidationResult = {
  htmlValid: boolean;
  jsValid: boolean;
};

export const validateSourceCode = (html: string): SourceValidationResult => {
  const htmlValid = isValidHTMLWithHint(html);
  const jsValid = areValidScriptBlocks(extractScriptBlocks(html));
  return { htmlValid, jsValid };
};

const TagsAssetEdit: React.FC = () => {
  const classes = apollo_useStyles();
  const history = useHistory();

  const { data, setmsg } = useContext(ApolloMessage);
  const { state } = useContext(ApolloContext);
  const { drawerState, setDrawerState } = useContext(ApolloRightDrawerContext);

  const { accountgroupid, accountid, platformaccountid } = useParams<{
    accountgroupid: string;
    accountid: string;
    platformaccountid: string;
  }>();

  const { register, handleSubmit, errors, control , getValues } = useForm();
  const [tags, setTags] = useState<tagsAsset>(INIT_TAGS);
  const [errorMessages, setErrorMessages] = useState("");
  const [tabstate, setTabstate] = useState(0);
  const [touched, setTouched] = useState({
    tagName: false,
    sourceCode: false,
  });

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 26,
    breadId: 2,
    queries: [],
    menu: { id: 1, accountId: platformaccountid, accountName: "" },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  };
  const validation = validateSourceCode(tags.sourceCode);

  useEffect(() => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${zeus_ad_account}${platformaccountid}`;
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      },
    }).then(response => {
      setTags(prev => ({ ...prev, zeusAccountName: response.data.name, adAccountId: isNaN(Number(platformaccountid)) ? 0 : Number(platformaccountid) }));
    }).catch(() => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "zeusアカウント名の取得に失敗しました",
        },
      });
    });
  }, []);

  const handelGoback = () => {
    setDrawerState({ type: 'close', payload: { ...drawerState, open: false } });
    setmsg({ type: "setMessage", payload: { ...data, open: false, type: "", message: "" } });
    history.push(isummary_path);
  };

  const onSubmit = async () => {
    if (!tags.tagName.trim()) {
      setTouched({ ...touched, sourceCode: true, tagName: true })
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "タグアセット名は必須です",
        },
      });
      return;
    }

    if (tags.tagName.length > MAX_TAG_NAME_LENGTH) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `タグアセット名は${MAX_TAG_NAME_LENGTH}文字以内で入力してください（現在：${tags.tagName.length}文字）`,
        },
      });
      return;
    }

    const errorMessage = checkInvalidCharForName(tags.tagName);
    if (errorMessage) {
      setmsg ({
          type: "setMessage",
          payload: {
              ...data,
              open: true,
              type: "error",
              message: errorMessage
      }});
      return;
    }
  
    if (!tags.sourceCode.trim()) {
      setTouched({ ...touched, sourceCode: true, tagName: true })
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ソースコードは必須です",
        },
      });
      return;
    }

    if (tags.sourceCode.length > MAX_SOURCE_LENGTH) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: `ソースコードは${MAX_SOURCE_LENGTH}文字以内で入力してください（現在：${tags.sourceCode.length}文字）`,
        },
      });
      return;
    }

    const { htmlValid, jsValid } = validateSourceCode(tags.sourceCode);

    if (!htmlValid) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ソースコードにHTML構文エラーがあります。タグの閉じ忘れなどをご確認ください。",
        },
      });
      return;
    }

    if (!jsValid) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ソースコードにJavaScript構文エラーがあります。scriptタグ内の文法を確認してください。",
        },
      });
      return;
    }

    const sourceCodeErrorMessage = getTextStrCheckErrorMsg(tags.sourceCode);
    if (sourceCodeErrorMessage) {
      setmsg ({
          type: "setMessage",
          payload: {
              ...data,
              open: true,
              type: "error",
              message: "ソースコードに禁止文字が入力されています。"
      }});
      return;
    }
  
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_tags_path}`;

    const size = getValues("size");

    // ソースコードだけBase64変換
    const payload = {
      ...tags,
      // サイズはreact-hook-form側から取得した値を優先
      width: size?.value?.width ?? tags.width,
      height: size?.value?.height ?? tags.height,
      sourceCode: utf8ToBase64(tags.sourceCode),
    };
  
    try {
      await axios.post(
        url,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          },
        }
      );
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "タグアセットの作成に成功しました",
        },
      });
      history.push(isummary_path);
    } catch (error) {
      const errMsg =
        axios.isAxiosError(error) && error.response?.data?.message
          ? error.response.data.message
          : "タグアセットの作成に失敗しました";
    
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        },
      });
    }
  };

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars />
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData} />
        <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["個別アップロード"]} />

        <ApolloTabPanel value={tabstate} index={0}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="adAccountId"
                    name="adAccountId"
                    inputRef={register}
                    label="パフォーマンス広告アカウントID"
                    disabled
                    fullWidth
                    autoComplete="パフォーマンス広告アカウントID"
                    defaultValue={platformaccountid}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="adAccountName"
                    name="adAccountName"
                    inputRef={register}
                    label="パフォーマンス広告アカウント名"
                    disabled
                    fullWidth
                    autoComplete="パフォーマンス広告アカウント名"
                    value={tags.zeusAccountName}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="tagName"
                    name="tagName"
                    inputRef={register}
                    label="タグアセット名"
                    fullWidth
                    autoComplete="タグアセット名"
                    value={tags.tagName}
                    onChange={(e) => setTags({ ...tags, tagName: e.target.value })}
                    onBlur={() => setTouched({ ...touched, tagName: true })}
                    error={
                      touched.tagName &&
                      (tags.tagName.trim() === "" || tags.tagName.length > MAX_TAG_NAME_LENGTH || checkInvalidCharForName(tags.tagName) != "")
                    }
                    helperText={
                      !touched.tagName
                        ? ""
                        : tags.tagName.trim() === ""
                        ? "必須入力です"
                        : tags.tagName.length > MAX_TAG_NAME_LENGTH
                        ? `255文字以内で入力してください（現在：${tags.tagName.length}文字）`
                        : checkInvalidCharForName(tags.tagName) != ""
                        ? checkInvalidCharForName(tags.tagName)
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>サイズ</Typography>
                  <Controller
                      name="size"
                      control={control}
                      defaultValue={options_size_zeus.find(
                          opt => opt.value.width === tags.width && opt.value.height === tags.height
                      )}
                      render={(props: any) => (
                          <Select
                              options={options_size_zeus}
                              components={animatedComponents}

                              // react-hook-formが持ってる値を表示に反映.
                              value={props.value}

                              // サイズメニューを前面に出す処理.
                              // プルダウン表示時に選択肢以外の文字列がプルダウン上に重なり合って表示されなくなる.
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base: any) => ({ ...base, zIndex: 2000 }),
                                menu: (base: any) => ({ ...base, zIndex: 2000 }),
                              }}

                              onChange={(selected: any) => {
                                // react-hook-form側へ反映.
                                props.onChange(selected);

                                // tags state側にも反映.
                                if (!selected) return;
                                setTags(prev => ({
                                  ...prev,
                                  width: selected.value.width,
                                  height: selected.value.height,
                                }));
                              }}

                              onBlur={props.onBlur}
                              name={props.name}
                              ref={props.ref}
                          />
                      )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>タグ種別</Typography>
                  <Controller
                    name="tagType"
                    control={control}
                    as={Select}
                    closeMenuOnSelect
                    components={animatedComponents}
                    defaultValue={options_tagtype_zeus.find(opt => parseInt(opt.value) === tags.tagType)}
                    options={options_tagtype_zeus}
                    onChange={([selected]: any) => {
                      setTags({
                        ...tags,
                        tagType: parseInt(selected.value),
                      });
                      return selected;
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>ソースコード</Typography>
                  <TextField
                    id="sourceCode"
                    name="sourceCode"
                    label="ソースコード"
                    fullWidth
                    multiline
                    minRows={8}
                    maxRows={20}
                    variant="outlined"
                    value={tags.sourceCode}
                    onChange={(e) => setTags({ ...tags, sourceCode: e.target.value })}
                    onBlur={() => setTouched({ ...touched, sourceCode: true })}
                    error={
                      touched.sourceCode &&
                      (
                        tags.sourceCode.trim() === "" ||
                        tags.sourceCode.length > MAX_SOURCE_LENGTH ||
                        !validation.htmlValid ||
                        !validation.jsValid || 
                        getTextStrCheckErrorMsg(tags.sourceCode) != ""
                      )
                    }
                    helperText={
                      !touched.sourceCode
                        ? ""
                        : tags.sourceCode.trim() === ""
                        ? "必須入力です"
                        : tags.sourceCode.length > MAX_SOURCE_LENGTH
                        ? `10,000文字以内で入力してください（現在：${tags.sourceCode.length}文字）`
                        : !validation.htmlValid
                        ? "HTML構文エラーがあります。タグの閉じ忘れなどをご確認ください。"
                        : !validation.jsValid
                        ? "JavaScript構文エラーがあります。scriptタグ内の文法を確認してください。"
                        : getTextStrCheckErrorMsg(tags.sourceCode) != ""
                        ? getTextStrCheckErrorMsg(tags.sourceCode)
                        : ""
                    }
                  />
                </Grid>
              </Grid>
              
              <Grid container xs={12} justifyContent="flex-end">
                <Button
                  type="button"
                  color="primary"
                  className={classes.button}
                  onClick={async () => {
                    let type = 0
                    const text = tags.sourceCode
                    await navigator.clipboard.writeText(text)
                    .then(()=>{type = 1})
                    .catch(()=>{type = -1})
                    .finally(()=>{
                      setmsg({
                        type: "setMessage",
                        payload: {
                          ...data,
                          open: true,
                          type: getResultType(type),
                          message: type === 1 ? "クリップボードにコピーしました。" : "コピーに失敗しました。",
                        }
                      });
                    });
                  }}
                  variant="contained"
                >
                  クリップボードにコピー
                </Button>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={
                  tags.tagName.trim() === "" ||
                  tags.sourceCode.trim() === "" ||
                  tags.tagName.length > MAX_TAG_NAME_LENGTH ||
                  tags.sourceCode.length > MAX_SOURCE_LENGTH ||
                  !validation.htmlValid || 
                  !validation.jsValid ||
                  getTextStrCheckErrorMsg(tags.sourceCode) != "" || 
                  checkInvalidCharForName(tags.tagName) != ""
                }
              >
                作成
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </ApolloTabPanel>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default TagsAssetEdit;
